import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';

export const Content = styled(motion.div)`
  height: 100%;
  background-color: ${COLORS.WHITE};
  font-size: 14px;
  line-height: 1.4em;
  letter-spacing: 0.02em;
  border: 1px solid ${COLORS.WILD_SAND};
  border-top: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 13px;
    right: 13px;
    top: 0;
    height: 1px;
    background-color: ${COLORS.BLACK10};
  }
`;
export const Container = styled.div<{ isOpen: boolean }>`
  position: absolute;
  left: 0;
  width: 100%;
  height: 60px;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  overflow-x: auto;
  z-index: 1;
`;

const getActiveStyles = css<{ active?: boolean }>`
  background-color: ${({ active }) => (active ? COLORS.GALLERY : 'transparent')};
  pointer-events: ${({ active }) => (active ? 'none' : 'auto')};
`;

export const SortButton = styled.button<{ active?: boolean }>`
  ${getActiveStyles};
  border-radius: 39px;
  padding: 3px 12px;
  line-height: 18px;
  letter-spacing: 0.1px;
`;

export const SortButtonsWrapper = styled.div`
  display: flex;

  ${media.tablet} {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const DirectionArrow = styled.button<{ active?: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  ${getActiveStyles};

  ${media.tablet} {
    margin-left: 9px;
  }
`;
